export default __webpack_public_path__ + "static/media/carousel2.f4b76c66.jpg";